{
  "width": 1536,
  "height": 1024,
  "gripBaseline": 800,
  "pawBottom": 870
}
